import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { URL_GLOBAL, URL_WS_CHAMADO } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ChamadoTiService {

  // UrlCnab = 'https://madelife.med.br:9025/api/Cnab';
  websocket: any = null;
  reconnect: any = null;
  need_reconnect: boolean = true;
  connecting: boolean = false;

  loading: boolean = true;
  observer: Subject<any> = new Subject<any>();
  socket: any = null;
  dataObservable: Observable<any>;
  constructor(private http: HttpClient) {
    this.dataObservable = this.observer.asObservable();
    console.log(this.dataObservable);

  }


  connect(token: any) {
    if (this.loading == true && this.connecting == false) {
      this.connecting = true;

      // this.socket = new WebSocket('wss://api.madelife.med.br:1122');
      this.socket = new WebSocket(URL_WS_CHAMADO);
      this.socket.addEventListener('open', (event) => {
        // Deserializamos o objeto
        console.log('reconnect');
        console.log(token);
        this.observer.next({ data: JSON.stringify({ type: 'conectou' }) });

        clearTimeout(this.reconnect);
        this.socket.send(JSON.stringify({ type: 'token', area: 'T.I.', token: token.access_token, token_type: token.token_type }));
        this.loading = false;

      });
      this.socket.addEventListener('message', (event) => {
        if (this.observer != undefined) {
          this.observer.next(event);
        }
      });

      this.socket.addEventListener('close', (event) => {
        // Deserializamos o objeto
        // Escrevemos no DOM
        this.loading = true;
        this.connecting = false

        this.observer.next({ data: JSON.stringify({ type: 'desconectou' }) });
        console.log('close');
        if (this.need_reconnect == true) {
          this.reconnect = setTimeout(() => {
            this.connect(token);
          }, 2000);
        }


      });
    }
    else if (this.loading == false) {
      this.observer.next({ data: JSON.stringify({ type: 'conectou' }) });

    }
  }





  getConversasTi(token): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<any[]>(`${URL_GLOBAL}/web/chat/chamados_ti`, { headers })
  }

  getConversasTiFinalizados(token): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<any[]>(`${URL_GLOBAL}/web/chat/chamados_ti_finalizados`, { headers })
  }

  getPessoas(token, name, ti = false): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<any[]>(`${URL_GLOBAL}/web/chat/get_pessoas_externo?search=${name}&ti=${ti}`, { headers })
  }

  enviar_arquivos(data, token): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.post<any>(`${URL_GLOBAL}/web/chat/enviarArquivos`, data, { headers });
  }

  criarChamadoTi(token: any, data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.post<any>(`${URL_GLOBAL}/web/chat/criarchamado_atendente_ti`, data, { headers });
  }

  finalizarChamadoTi(token: any, data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.post<any>(`${URL_GLOBAL}/web/chat/finalizarchamado_ti`, data, { headers });
  }

  getYearsOfChamados(token: any): Observable<Array<{ year: number }>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<Array<{ year: number }>>(`${URL_GLOBAL}/web/chat/chamados/years`, { headers });
  }

  getAllChamados(token: any, year: number): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/chat/chamados/year/${year}`, { headers });
  }

  getCountChamados(token: any, year: number): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/chat/chamados/count/year/${year}`, { headers });
  }

  getChamadosByMonthYear(token: any, year: number): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/chat/chamados/month/year/${year}`, { headers });
  }

}
